import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TooltipTypeEnum } from 'src/app/model/Enums/TooltipPosition/toolTipPositionenum.enum';

@Component({
    selector: 'app-common-icon',
    templateUrl: './common-icon.component.html',
    styleUrls: ['./common-icon.component.scss'],
    standalone: false
})
export class CommonIconComponent {
  @Input() name: string;
  @Input() iconClass: string;
  @Input() isSideBar: boolean = false;
  @Input() iconTooltip: string;
  @Input() iconTooltipPosition: string;
  @Output() onDismissEvent = new EventEmitter();

  public toolTipPosition = TooltipTypeEnum.positionTop;

  onDismiss() {
    this.onDismissEvent.emit();
  }
}
